import project from 'reducers/project';
import { createSelector } from 'reselect';
import { globalEditorSelector } from 'selectors/userSelector';

const currentProjectSelector = createSelector(
  // projects will change because it changes when this does, so if this changes when projects change all updates will trigger changes
  (state) => _.find(state.projects, {id: state.currentProjectID}),
  (state) => globalEditorSelector(state),
  (project, isGlobalEditor) => {
    // we need to memoize read-only, as well as the current project to avoid unnecessary changes
    return Object.assign({}, project, {readonly: !project?.owned && !isGlobalEditor});
  }
);

const currentProjectDelegateSelector = createSelector(
  (state) => state,
  (state, action) => project(currentProjectSelector(state), action),
  (state, currentProject) => {
    // We update state here, and by extension project if and only if the current project has changed.
    return {
      ...state,
      projects: _.map(state.projects, (state) => {
        return state.id === currentProject.id ? currentProject : state;
      }),
    };
  }
)

export default currentProjectDelegateSelector;
